import { CONTACTS } from "./contacts";

const NAME = "Барбершоп 99";

export const SITE = {
	name: NAME,
	// Заголовок вкладки и сниппета в поиске: название, город и главные услуги
	title: `${NAME} в Калининграде — мужские стрижки и борода`,
	// Описание для сниппета. Адрес и часы подставляются из контактов
	description: `${NAME} в Калининграде: мужские и детские стрижки, стрижка бороды и усов, комплексы. ${CONTACTS.address.short}, ${CONTACTS.hours.short.toLowerCase()}. Онлайн-запись.`,
	url: "",
} as const;
